import { FC, useEffect, useState } from "react"
import { OdResourcePageProps } from "@/types/resource"
import { Content } from "@/components/content/Content"
import DatabaseMappingList from "./DatabaseMappingList"
import { TabContext, TabPanel } from "@mui/lab"
import { Tabs, Tab, Box } from "@mui/material"
import FileMappingList from "./FileMappingList"
import { useLocation } from "react-router-dom"
import { parse } from "@/utils/queryStringWrapper"
import { useDispatch } from "react-redux"
import { push } from "connected-react-router"


type MappingKind = 'database' | 'file'

const EncryptionMappings: FC<OdResourcePageProps> = ({
  options,
  resource,
}) => {
  const location = useLocation()
  const tabQuery = parse(location.search)['tab'] === 'file' ? 'file' : 'database'
  const [currTab, setCurrTab] = useState<MappingKind>(tabQuery)
  const dispatch = useDispatch()
  useEffect(() => { 
    if (location.search) {dispatch(push(location.pathname))}
  }, [location.pathname, location.search, dispatch])
  

  return (
    <Content pageName="Encryption Mappings" resourceName="Encryption Mappings" breadcrumbs={options?.breadcrumbs}>
      <TabContext value={currTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: -1.5 }}>
          <Tabs
            indicatorColor="secondary"
            onChange={(e:any, newVal:MappingKind) => setCurrTab(newVal)}
            scrollButtons="auto"
            textColor="secondary"
            value={currTab}
            variant="scrollable"
          >
            <Tab label="Database" value="database" />
            <Tab label="File" value="file" />
          </Tabs>
        </Box>
        <Box sx={{ '& div.MuiTabPanel-root': { pt: 2, px: 0 } }}>
          <TabPanel value="database">
            <DatabaseMappingList />
          </TabPanel>
          <TabPanel value="file">
            <FileMappingList />
          </TabPanel>
        </Box>
      </TabContext>
    </Content>
  )
}


export default EncryptionMappings;
